"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanGroupsLoader = void 0;
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_1 = require("react");
const useDataTreeActions_1 = __importDefault(require("../../useDataTreeActions"));
function BooleanGroupsLoader(props) {
    const { groupBy } = props;
    const { setGroupCollectionForGroupBy } = (0, useDataTreeActions_1.default)();
    (0, react_1.useEffect)(() => {
        const queryField = QueryFieldRegistry_1.default[groupBy.queryFieldKey];
        setGroupCollectionForGroupBy(groupBy, {
            loading: false,
            lastLoaded: new Date(),
            totalCount: 2,
            groups: [
                Object.assign(Object.assign({}, groupBy), { id: 'TRUE', title: (0, getFromStringOrFunction_1.getFromStringOrFunction)(queryField.label), color: lib_palette_1.default.positive }),
                Object.assign(Object.assign({}, groupBy), { id: 'FALSE', title: 'Not ' + (0, getFromStringOrFunction_1.getFromStringOrFunction)(queryField.label), color: lib_palette_1.default.CoralRed }),
            ],
        });
    }, [groupBy, setGroupCollectionForGroupBy]);
    return null;
}
exports.BooleanGroupsLoader = BooleanGroupsLoader;
exports.default = BooleanGroupsLoader;
